import React from 'react';
import './../../../pages/Representante_Instituição/Tela_RI_Cadastro/styles.css';
import axios from 'axios';
import { user_token } from '../../../services/Auth';

var token = localStorage.getItem(user_token);

export default class Form_PM extends React.Component {

//PATCH LOGIC
constructor() {
    super();
    this.state = {
        monitoration_record: [],
        
    };
    this.handleChange = this.handleChange.bind(this);
}
handleChange(evt) {
    this.setState({ [evt.target.name]: evt.target.value });
}

handleSubmit = evt => {
    evt.preventDefault();

    const prontuario = {            
        monitoration_record_aux: this.state.monitoration_record.push( {
            "monitoration_record": { 
                "date": "07/05/2020",
                "anamnese": "não houve nenhuma atualização",
                "referrals": "nenhum",
                "professional_cpf": 10101010,
                "professional_name": "João",
                "note": "nada a adicionar",
                
                "medications_in_use": "Não",
                
                "life_habits": {
                    "physical_activity": true,
                    "smoking": true,
                    "smoking_amount": 3,
                    "alcoholism": true,
                    "alcoholism_amount": 4,
                    "surgery": ""
                }
            
            }
        } ),
        monitoration_record: this.state.monitoration_record,

    };

    console.log(prontuario)
    //ID está setada -> Necessário Correção
    axios.patch(`http://api-convida.herokuapp.com/user`, prontuario, {headers: {'x-access-token': token}} )
        .then(res => {
            console.log(res);
            console.log(res.data);
        })

}

render() {
    return (
        <form onSubmit={this.handleSubmit} id="forms-RI-Cadastro">
            <h1 id="tittle-forms-cme">Prontuário de Monitoração</h1>
            <br></br>
            <p id="RI-Title-Cadastro" >Medicamentos em uso</p>
            <input onChange={this.handleChange} name="medications_in_use" placeholder="Medicamentos em uso" id="RI-Cadastro" />
            <p type="ratio" id="RI-Title-Cadastro">Pratica atividade física regularmente?</p>
            <select id="Pront_Init" onChange={this.handleChange} name="physical_activity">
                <option value="Y">Sim</option>
                <option value="N">Não</option>
            </select>
            <p type="ratio" id="RI-Title-Cadastro">Tabagismo</p>
            <select id="Pront_Init" onChange={this.handleChange} name="smoking">
                <option value="Y">Sim</option>
                <option value="N">Não</option>
            </select>
            <p id="RI-Title-Cadastro" >Se a resposta acima for sim, quantos cigarros o paciente fuma por dia?</p>
            <input onChange={this.handleChange} name="smoking_amount" placeholder="Quantidade de cigarros por dia" id="RI-Cadastro" />
            <p type="ratio" id="RI-Title-Cadastro">Alcoolismo</p>
            <select id="Pront_Init" onChange={this.handleChange} name="physical_activity">
                <option value="Y">Sim</option>
                <option value="N">Não</option>
            </select>
            <p id="RI-Title-Cadastro" >Se a resposta acima for sim, quanto o paciente beb por dia?</p>
            <input onChange={this.handleChange} name="smoking_amount" placeholder="Quantidade consumida por dia" id="RI-Cadastro" />
            <p id="RI-Title-Cadastro" >Histórico de Cirurgias:</p>
            <input onChange={this.handleChange} name="surgery" placeholder="Histórico de Cirurgia" id="RI-Cadastro" />

            <p id="RI-Title-Cadastro" >Data:</p>
            <input onChange={this.handleChange} name="date" placeholder="Insira a data e hora: " id="RI-Cadastro" />
            <p id="RI-Title-Cadastro" >Atualização:</p>
            <input onChange={this.handleChange} name="anamnese" placeholder="Insira atualizações: " id="RI-Cadastro" />
            <p id="RI-Title-Cadastro" >Referências:</p>
            <input onChange={this.handleChange} name="referrals" placeholder="Insira referências: " id="RI-Cadastro" />
            <p id="RI-Title-Cadastro" >CPF do Profissional:</p>
            <input onChange={this.handleChange} name="professional_cpf" placeholder="Insira seu CPF: " id="RI-Cadastro" />
            <p id="RI-Title-Cadastro" >Nome do Profissional:</p>
            <input onChange={this.handleChange} name="professional_name" placeholder="Insira seu nome: " id="RI-Cadastro" />
            <p id="RI-Title-Cadastro" >Observações:</p>
            <input onChange={this.handleChange} name="note" placeholder="Insira observações: " id="RI-Cadastro" />
            <button onClick={() => this.handleSubmit} id="RI-Cadastro">Enviar</button>
                
        </form>
    );
}
}
                